"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CurrencyFormatter {
    currency;
    locale;
    minimumFractionDigits;
    maximumFractionDigits;
    currencyDisplay;
    customSymbol;
    constructor({ currency, locale = 'en-US', minimumFractionDigits = 2, maximumFractionDigits = 2, currencyDisplay = 'symbol', customSymbol, }) {
        this.currency = currency;
        this.locale = locale;
        this.minimumFractionDigits = minimumFractionDigits;
        this.maximumFractionDigits = maximumFractionDigits;
        this.currencyDisplay = currencyDisplay;
        this.customSymbol = customSymbol;
    }
    format(value) {
        let formattedValue = new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
            minimumFractionDigits: this.minimumFractionDigits,
            maximumFractionDigits: this.maximumFractionDigits,
            currencyDisplay: this.currencyDisplay,
        }).format(value);
        if (this.customSymbol && this.currencyDisplay === 'symbol') {
            const currencySymbol = formattedValue.match(/[\p{Sc}\p{L}]+/u)?.[0] ?? '';
            formattedValue = formattedValue.replace(currencySymbol, this.customSymbol);
        }
        return formattedValue;
    }
    formatCustom(value, options) {
        return new Intl.NumberFormat(options.locale || this.locale, {
            style: 'currency',
            currency: options.currency || this.currency,
            minimumFractionDigits: options.minimumFractionDigits ?? this.minimumFractionDigits,
            maximumFractionDigits: options.maximumFractionDigits ?? this.maximumFractionDigits,
            currencyDisplay: options.currencyDisplay || this.currencyDisplay,
        }).format(value);
    }
    getFormatterConfig() {
        return {
            currency: this.currency,
            locale: this.locale,
            minimumFractionDigits: this.minimumFractionDigits,
            maximumFractionDigits: this.maximumFractionDigits,
            currencyDisplay: this.currencyDisplay,
        };
    }
}
exports.default = CurrencyFormatter;
